import { FAIcon, Theme, Tag, TagStyle, SearchDataStructure, AttributeTypes } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';
import { dateTimeToCustomFormat, formatDateDMYYYY } from '../../../ui/utils';
export interface CoachData {
  recId: number;
  aboId: string;
  campaignId: string;
  campaignName: string;
  configJson: DynamicObjectInterface;
  coachId: string | null;
  cumulativePoint: {
    point: string;
    pointAdj: string;
    lastUpdateDate?: string;
  };
  directLeader: number;
  directLeaderName: string;
  directLeaderPin: string;
  endDate: string;
  enrollmentDate: string;
  enrollmentType: string;
  name: string;
  newAboCount: {
    point: string;
    pointAdj: string;
    lastUpdateDate?: string;
  };
  newGroupAboCount: {
    point: string;
    pointAdj: string;
    lastUpdateDate?: string;
  };
  pin: string;
  remark: string;
  status: string;
  totalTeams: number;
  totalTeamAchieved?: number;
  pointRemark?: string;
  totalPoint?: string;
  totalPersonalSponsor?: string;
  totalGroupSponsor?: string;
  teams: {
    teamId: string;
    teamName: string;
    totalWeightIn: number;
    totalWeightOut: number;
    totalPoint: number;
  }[];
  rewards: {
    rewardRemarks?: string;
    rewardId?: number;
    rewardCode?: string;
    rewardName?: string;
    isNew?: boolean;
    rewardRecId: string;
    rewardStatus?: string;
    rewardModifiedDate?: string;
    rewardType?: string;
  }[];
  achievement: {
    completed: number;
    achieved: number;
    alp: number;
    sponsor: number;
  };
}

export interface MasterData {
  campaign: {
    campaignEnd?: string;
    campaignId?: string;
    campaignName?: string;
    campaignStart: string;
    recId?: number;
    status?: string;
  }[];
  reward?: {
    recId: number;
    rewardCode: string;
    rewardName: string;
  }[];
}
export interface CampaignOption {
  campaignEnd: string;
  campaignId: string;
  campaignName: string;
  campaignStart: string;
  status: string;
  title: string;
  value: string;
}

export const dataSearchOption: SearchDataStructure[] = [
  {
    name: 'Team Leader ID',
    key: 'coachId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Team Leader Name',
    key: 'name',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Team Leader ABO ID',
    key: 'aboId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
];

export const getCoachListConfig: GetColumnsType = (
  styles: Object,
  translation: Function,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'coachId',
    text: translation('admin.generalCoach.coachId'),
    width: 2,
    sortable: true,
    render: (object: DynamicObjectInterface) => <span>{object.coachId}</span>,
  },
  {
    key: 'coachName',
    text: translation('admin.generalCoach.coachName'),
    sortable: true,
    width: 4,
    render: (object: DynamicObjectInterface) => <span>{object.name}</span>,
  },
  {
    key: 'aboId',
    text: translation('admin.generalCoach.aboId'),
    sortable: true,
    width: 2,
    render: (object: DynamicObjectInterface) => <span>{object.aboId}</span>,
  },
  {
    key: 'totalTeams',
    text: translation('admin.generalCoach.totalTeams'),
    sortable: true,
    width: 3,
    render: (object: DynamicObjectInterface) => <span>{object.totalTeams}</span>,
  },
  {
    key: 'totalTeamAchieved',
    text: translation('admin.generalCoach.totalTeamAchieved'),
    sortable: true,
    width: 3,
    render: (object: DynamicObjectInterface) => <span>{object.totalTeamAchieved}</span>,
  },
  {
    key: 'totalNewAbo',
    text: translation('admin.generalCoach.totalnewAbo'),
    sortable: true,
    width: 3,
    render: (object: DynamicObjectInterface) => <span>{object.numOfTotalNewAbo}</span>,
  },
  // {
  //   key: 'totalTeamWinning',
  //   text: translation('admin.generalCoach.totalTeamWinning'),
  //   sortable: true,
  //   width: 3,
  //   render: (object: DynamicObjectInterface) => <span>{object.totalTeamWinning}</span>,
  // },
  // {
  //   key: 'completedCount',
  //   text: translation('admin.generalCoach.completedCount'),
  //   sortable: true,
  //   width: 2,
  //   render: (object: DynamicObjectInterface) => <span>{object.completedCount}</span>,
  // },
  // {
  //   key: 'achievedCount',
  //   text: translation('admin.generalCoach.achievedCount'),
  //   sortable: true,
  //   width: 2,
  //   render: (object: DynamicObjectInterface) => <span>{object.achievedCount}</span>,
  // },
  // {
  //   key: 'ALPCount',
  //   text: translation('admin.generalCoach.ALPCount'),
  //   sortable: true,
  //   width: 2,
  //   render: (object: DynamicObjectInterface) => <span>{object.ALPCount}</span>,
  // },
  // {
  //   key: 'totalPersonalSponsor',
  //   text: translation('admin.generalCoach.personalSponsor'),
  //   sortable: true,
  //   width: 4,
  //   render: (object: DynamicObjectInterface) => <span>{object.totalPersonalSponsor}</span>,
  // },
  // {
  //   key: 'qualified',
  //   text: translation('admin.generalCoach.qualified'),
  //   sortable: true,
  //   width: 4,
  //   render: (object: DynamicObjectInterface) => <span>{object.qualified ? 'YES' : 'NO'}</span>,
  // },
  {
    key: 'action-func',
    width: 1,
    text: 'Action',
    render: (object: DynamicObjectInterface) => (
      <FAIcon
        iconName={'edit'}
        onClick={e => {
          cb?.onEdit(object);
          e.stopPropagation();
        }}
        theme={Theme.PURPLE}
        title={'Edit'}
      />
    ),
  },
];

type ICoachBO = {
  [key: string]: DynamicObjectInterface;
};

export const getRewardListConfig: GetColumnsType = (
  styles: Object,
  translation: Function,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'rewardName',
    text: translation('admin.rewardMaster.rewardName'),
    sortable: true,
    width: 14,
    render: (object: ICoachBO) => <span>{object.rewardName}</span>,
  },
  {
    key: 'rewardStatus',
    text: translation('admin.rewardMaster.status'),
    sortable: true,
    width: 5,
    render: (object: ICoachBO) => <span>{object.rewardStatus}</span>,
  },
  {
    key: 'modifiedDate',
    text: translation('admin.participant.lastUpdated'),
    sortable: true,
    width: 5,
    render: (object: ICoachBO) => (
      <span>{object.rewardModifiedDate ? formatDateDMYYYY(new Date(object.rewardModifiedDate)) : null}</span>
    ),
  },
];

export const getTeamListConfig: GetColumnsType = (
  styles: Object,
  translation: Function,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'teamName',
    text: translation('admin.teams.teamName'),
    sortable: true,
    width: 5,
    render: (object: ICoachBO) => <span>{object?.teamName}</span>,
  },
  {
    key: 'period',
    text: translation('admin.teams.period'),
    sortable: true,
    width: 4,
    render: (object: ICoachBO) => (
      <span>
        {object?.teamStartDate
          ? dateTimeToCustomFormat(object?.teamStartDate?.toString() ?? '', 'DD/MM/yyyy') +
            ' - ' +
            dateTimeToCustomFormat(object?.teamEndDate?.toString() ?? '', 'DD/MM/yyyy')
          : ''}
      </span>
    ),
  },
  // {
  //   key: 'isMeasured',
  //   text: translation('admin.teams.isMeasured'),
  //   sortable: true,
  //   width: 3,
  //   render: (object: ICoachBO) => (
  //     <span>
  //       <Tag
  //       theme={
  //         object.isMeasured === 1
  //           ? Theme.SUCCESS
  //           : Theme.WARNING
  //       }
  //       style={TagStyle.OUTLINE}
  //       text={object.isMeasured === 1 ? 'YES' : 'NO'}
  //     />
  //     </span>
  //   ),
  // },
  {
    key: 'newABO',
    text: translation('admin.participant.isNewAbo'),
    sortable: true,
    width: 3,
    render: (object: ICoachBO) => <span>{object.newABO}</span>,
  },
  {
    key: 'isGroupAchieved',
    text: translation('admin.teams.isGroupAchieved'),
    sortable: true,
    width: 3,
    render: (object: ICoachBO) => (
      <span>
        <Tag
          theme={
            object.isGroupAchieved === 1 ? Theme.SUCCESS : object.isGroupAchieved === 0 ? Theme.WARNING : Theme.BLUE
          }
          style={TagStyle.OUTLINE}
          text={object.isGroupAchieved === 1 ? 'YES' : object.isGroupAchieved === 0 ? 'NO' : 'PENDING'}
        />
      </span>
    ),
  },
  {
    key: 'status',
    text: translation('admin.teams.status'),
    sortable: true,
    width: 3,
    render: (object: ICoachBO) => (
      <span>
        <Tag
          theme={object.teamStatus === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.teamStatus}
        />
      </span>
    ),
  },
  {
    key: 'action-func',
    width: 1,
    text: 'Action',
    render: (object: ICoachBO) => (
      <FAIcon
        iconName={'edit'}
        onClick={e => {
          cb?.onEdit(object);
          e.stopPropagation();
        }}
        theme={Theme.PURPLE}
        title={'Edit'}
      />
    ),
  },
];
